// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GZAa","type":"styles_type__Mbp-0","choices":"styles_choices__TMHvx"};